import { Reveal, Chapter } from "@/components/Reveal";
import LeadForm from "@/components/LeadForm";

const CRITERIA = ["Marque", "Modèle", "Année", "Budget", "Kilométrage", "Équipement", "Couleur", "Type de véhicule"];

export default function PrivateSearch() {
  return (
    <section id="recherche" data-testid="private-search-section" className="py-24 md:py-32 bg-anthracite/60">
      <div className="container-x grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-5">
          <Reveal>
            <Chapter number="02" label="Service de recherche privée" />
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-white leading-[1.1] tracking-tight">
              Quel véhicule
              <br />
              <span className="gold-text">recherchez-vous ?</span>
            </h2>
            <p className="mt-7 text-sm sm:text-base text-slate-400 font-light leading-relaxed">
              Pour les clients qui recherchent un véhicule précis. Décrivez-nous votre cible — nous
              activons notre réseau selon chacun de vos critères :
            </p>
          </Reveal>
          <Reveal delay={0.12}>
            <ul className="mt-8 grid grid-cols-2 gap-x-6 gap-y-3" data-testid="private-search-criteria">
              {CRITERIA.map((c, i) => (
                <li key={c} className="flex items-center gap-3 text-sm text-slate-300 font-light">
                  <span className="font-mono text-[10px] text-gold/70">{String(i + 1).padStart(2, "0")}</span>
                  {c}
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
        <div className="lg:col-span-7">
          <Reveal delay={0.15}>
            <div className="card-lux !p-8 sm:!p-10">
              <LeadForm type="recherche" testid="form-private-search" />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
